import { Facebook, Instagram } from "lucide-react";
import { SITE } from "@/config/sections";
import { PAYMENT } from "@/constants/testIds";

const TikTok = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48Z" />
  </svg>
);

const ICONS = { tiktok: TikTok, instagram: Instagram, facebook: Facebook };

export const FollowKiddee = () => (
  <section data-testid={PAYMENT.follow} className="mt-12 rounded-[2rem] bg-[#1C1917] text-white px-6 py-8 text-left sm:text-center">
    <p className="text-xs uppercase tracking-[0.2em] text-[#F2B544]">While your order gets packed</p>
    <h2 className="font-heading mt-2 text-2xl font-extrabold">Follow Kiddee</h2>
    <p className="mt-2 text-sm text-stone-300">New toy tests, unboxings and the occasional zoomies, every week.</p>
    <div className="mt-5 flex flex-wrap sm:justify-center gap-3">
      {SITE.socials.map((s) => {
        const Icon = ICONS[s.id];
        return (
          <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={PAYMENT.followLink(s.id)}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 hover:bg-[#E06D44] hover:-translate-y-0.5 transition-[background-color,transform] text-sm font-semibold">
            {Icon && <Icon size={18} />} {s.label}
          </a>
        );
      })}
    </div>
  </section>
);
